<template>
  <div class="footer">
    <div class="footer-content">
      <div class="item">
        <p>
          <span>{{ info.addrCode }}</span>
          <span class="version-right">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="version-num">蒙ICP备16005155号-5</a>
          </span>
        </p>
      </div>
      <div class="item">
        <div class="item-phone">
          <img src="../../../assets/images/keqi/克旗首页-2_07.png" alt="">
        </div>
        <div class="item-right">
          <div>全国统一热线</div>
          <div>{{ info.customerService }}</div>
        </div>
      </div>
      <div class="item">
        <img src="../../../assets/images/keqi/wexin.png" alt="">
        <div class="item-wexin">微信公众号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
  },
}
</script>

<style scoped lang="scss">
.footer{
  width: 100%;
  background: #373c40;
  .footer-content {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .item:first-child {
      flex: 4;
      p {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
        .version-right {
          padding-left: 20px;
          .version-num {
            font-size: 12px;
            color: #999;
            font-weight: bold;
          }
        }
      }
    }
    .item:nth-child(2) {
      width: 260px;
      display: flex;
      align-items: center;
      .item-phone {
        width: 60px;
      }
      .item-right {
        flex: 1;
        color: #fff;
        font-size: 22px;
        font-weight: 700;
      }
    }
    .item:last-child {
      img {
        width: 60px;
        height: 60px;
      }
      .item-wexin {
        padding-top: 5px;
        color: #fff;
        font-size: 12px;
      }
    }
  }  
}
</style>


// WEBPACK FOOTER //
// src/pages/keqi/components/footer.vue